import React from 'react';
import { Row, Col, Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { TableCell } from '../index';

const renderValues = (headings = []) => {
  return headings.map(
    (
      {
        onClick,
        title,
        lg,
        CustomComponent,
        customClass,
        CustomCell,
        customTextClass
      },
      index
    ) => {
      const lastIndex = headings.length - 1;
      const isLast = index === lastIndex;
      const textClassName = cn(
        'truncate',
        {
          'pr-5': !isLast && lg >= 2,
          'pr-3': !isLast && lg < 2
        },
        customTextClass
      );

      if (CustomComponent) {
        return (
          <Col key={index} lg={lg || null} className={customClass}>
            {CustomComponent}
          </Col>
        );
      }
      if (CustomCell) {
        const { title, subTitle } = CustomCell;
        return (
          <Col
            key={index}
            lg={lg || null}
            className={cn('row-item', customClass)}
          >
            <TableCell.Column>
              <TableCell.Text className={textClassName}>{title}</TableCell.Text>
              <TableCell.Text
                size="sm"
                variant="muted"
                className={textClassName}
              >
                {subTitle}
              </TableCell.Text>
            </TableCell.Column>
          </Col>
        );
      }
      return (
        <Col
          key={index}
          lg={lg || null}
          onClick={onClick}
          className={cn('row-item', { clickable: onClick }, customClass)}
        >
          <TableCell.Text className={textClassName}>{title}</TableCell.Text>
        </Col>
      );
    }
  );
};

const CustomTableRow = ({
  href,
  values,
  disabled = false,
  showExtraData = false,
  extraData,
  onClick = () => {},
  customTableRowWrapClass,
  customTableRowClass,
  customTableRowExtraDataClass
}) => {
  if (href) {
    return (
      <Link to={href} className="CustomTable__linkedRow" onClick={onClick}>
        <Row className="no-gutters table-row">{renderValues(values)}</Row>
      </Link>
    );
  }

  return (
    <div
      className={cn('table-row__wrapper', customTableRowWrapClass, {
        disabled: !!disabled
      })}
      onClick={() => !disabled && onClick()}
    >
      <Row className={cn('no-gutters', 'table-row', customTableRowClass)}>
        {renderValues(values)}
      </Row>
      {extraData && (
        <Collapse isOpen={showExtraData} timeout={100}>
          <Row
            className={cn('table-row__collapse', customTableRowExtraDataClass)}
          >
            {renderValues(extraData)}
          </Row>
        </Collapse>
      )}
    </div>
  );
};
export default CustomTableRow;
